<template>
  <div class="confirm-form">
    <h3 class="text-center">剩餘數量: <span style="color: red">{{ residual }}</span></h3>
    <h6 class="text-center" v-if="!allowToNext">{{ warnMessage }}</h6>
     <div class="button-wrap">
      <button class="btn  btn-lg confirm-button" @click="goOn" :disabled="!allowToNext">繼續動作</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionBreak',
  props: ['residual'],
  methods: {
    goOn() {
      this.$emit('goOn');
    },
  },
  computed: {
    errorDevices() {
      return this.$store.state.device.errorDevices;
    },
    nextDevice() {
      return this.$store.state.device.nextDevice;
    },
    currentDevice() {
      return this.$store.state.device.currentDevice;
    },
    allowToNext() {
      if (this.nextDevice.net.id === this.currentDevice.net.id && this.errorDevices.length < 2) {
        return true;
      }

      if (this.nextDevice.net.id !== this.currentDevice.net.id && this.errorDevices.length === 0) {
        return true;
      }

      return false;
    },
    warnMessage() {
      if (this.nextDevice.net.id === this.currentDevice.net.id && this.errorDevices.length > 1) {
        return '請先關閉藥盒';
      }
      if (this.nextDevice.net.id !== this.currentDevice.net.id && this.errorDevices.length > 0) {
        return '請先關閉所有藥盒及抽屜';
      }
      return '';
    },
  },
};
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// ActionBreak.vue?3d9d820a